import React, { useEffect, useState } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AOS from "aos";
import "aos/dist/aos.css";
import AdminSidebar from "../Side/AdminSidebar";
import { useAuth } from "../Auth/AuthContext";
import Loader from "../Animations/Loader"; // Import your Loader component
import WebAnalyticsTable from "../Dashboards/WebAnalyticsTable";

const WebAnalytics = () => {
    const { authState } = useAuth(); // Get authState from AuthContext
    const role = authState.roles;
    const admin = role === "Admin";
    const [loading, setLoading] = useState(true); // Start with loading state

    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: true, // Animation happens only once
        });

        // Check when the content is ready
        setLoading(false); // Content is ready, hide loader
    }, []);

    if (loading) {
        return <Loader />; // Show loader only when the page is actually loading
    }

    return (
        <div className="min-h-screen flex flex-col md:flex-row overflow-hidden">
            {/* Sidebar */}
            {admin ? <AdminSidebar /> : <Sidebar />}
    
            {/* Main Content */}
            <div className="flex-1 bg-gray-100 overflow-hidden">
                <div className="flex-1 flex flex-col">
                    <Topbar />
    
                    {/* Main Content */}
                    <main className="pt-[60px] px-4">
                        <div className="mt-6">
                            <WebAnalyticsTable />
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
    
};

export default WebAnalytics;
